import type { KpiFormulaNodeWithMetric, Metric } from '../../schemas/view_config/kpi.ts'

/**
 * KPI formula から Metric を取り出す純粋関数。
 * inline (`sheet/measure/date/user`) → Metric の変換は producer (BE `attachMetricToView` /
 * FE `attachMetricToKpiConfig`) に一意化したため、compile 側は再導出せず formula.metric のみを参照する。
 * `type: 'empty'` (= 未設定 KPI) は `undefined` を返し、呼び出し側の
 * `logs.warn('KPI設定が完了していません')` 経路へ流す。
 */
export const getMetricFromKpiFormula = (formula: KpiFormulaNodeWithMetric): Metric | undefined =>
  formula.type === 'ref' ? formula.metric : undefined
